<div class="ibox detailed-view-ibox" *ngIf="parkingPassService.showDetailedView && parkingPassService.selectedItemData">
    <div class="detailed-view-header">
        <div class="detailed-view-amenity-name">
            Booking ID: {{parkingPassService.selectedItemData.bookingNumber}}
        </div>
        <span class="close-detailed-view" (click)="parkingPassService.toggleDetailedView(null, false)">×</span>
    </div>
    <div class="detailed-view-body">
        <div class="detailed-view__more-info m-t-md">
            <form #form="ngForm" *ngIf="parkingPassService.selectedItemData"
                  [ngClass]="{'ng-submitted': form.submitted, 'resident-view': authenticationService.userIsResident}"
                  autocomplete="off">
                <div class="detailed-view-navigation" *ngIf="!authenticationService.userIsResident">
                    <div class="col-md-6 col-sm-6 col-xs-6 no-padding">
                        <div class="button-section" (click)="navPosition = 'info';"
                             [ngClass]="{'active': navPosition == 'info'}">
                            Info
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-6 no-padding">
                        <div class="button-section" (click)="navPosition = 'stats';"
                             [ngClass]="{'active': navPosition == 'stats'}">
                            Stats
                        </div>
                    </div>
                    <!--<div class="col-md-4 col-sm-4 col-xs-4 no-padding">-->
                        <!--<div class="button-section" (click)="navPosition = 'history';"-->
                             <!--[ngClass]="{'active': navPosition == 'history'}">-->
                            <!--History-->
                        <!--</div>-->
                    <!--</div>-->
                </div>
                <div *ngIf="navPosition == 'info'" class="content">
                    <div class="row m-b-xs">
                        <div class="dv-label col-md-3">
                            <label>Status</label>
                        </div>
                        <div class="dv-value col-md-9">
                            <span *ngIf="parkingPassService.selectedItemData.status === 'approved'">
                                <span *ngIf="parkingPassService.selectedItemData.timeRelatedStatus === 'current'"
                                      class="label label-current">
                                    Current
                                </span>
                                <span *ngIf="parkingPassService.selectedItemData.timeRelatedStatus === 'future'"
                                      class="label label-future">
                                    Future
                                </span>
                                <span *ngIf="parkingPassService.selectedItemData.timeRelatedStatus === 'past'"
                                      class="label label-past">
                                    Past
                                </span>
                            </span>
                            <span *ngIf="parkingPassService.selectedItemData.status === 'pending'"
                                  class="label label-pending">
                                Pending
                            </span>
                            <span *ngIf="parkingPassService.selectedItemData.status === 'declined'"
                                  class="label label-declined">
                                Declined
                            </span>
                        </div>
                    </div>

                    <div class="row m-b-sm">
                        <div class="dv-label col-md-3">
                            <label>Building</label>
                        </div>
                        <div class="dv-value col-md-9">
                            {{parkingPassService.selectedItemData.buildingName}}
                        </div>
                    </div>

                    <div class="row m-b-sm">
                        <div class="dv-label col-md-3">
                            <label>Unit</label>
                        </div>
                        <div class="dv-value col-md-9">
                            {{parkingPassService.selectedItemData.suiteNumber}}
                        </div>
                    </div>

                    <div class="row m-b-sm">
                        <div class="dv-label col-md-3">
                            <label>Resident</label>
                        </div>
                        <div class="dv-value col-md-9">
                            {{parkingPassService.selectedItemData.residentFullName}}
                        </div>
                    </div>

                    <div class="row m-b-xs">
                        <div class="dv-label col-md-3">
                            <label>Parking Lot</label>
                        </div>
                        <div class="dv-value col-md-9">
                            <span>{{parkingPassService.selectedItemData.bookingParkingLot ? parkingPassService.selectedItemData.bookingParkingLot.name : '-'}}</span>
                        </div>
                    </div>

                    <div class="row m-b-xs">
                        <div class="dv-label col-md-3">
                            <label>Visitor</label>
                        </div>
                        <div class="dv-value col-md-9">
                            <span>{{parkingPassService.selectedItemData.visitorFullName}}</span>
                        </div>
                    </div>

                    <div class="row m-b-xs">
                        <div class="dv-label col-md-3">
                            <label>Vehicle</label>
                        </div>
                        <div class="dv-value col-md-9">
                            <span>{{parkingPassService.selectedItemData.visitorVehicle}}</span>
                        </div>
                    </div>

                    <div class="row m-b-xs">
                        <div class="dv-label col-md-3">
                            <label>Licence Plate</label>
                        </div>
                        <div class="dv-value col-md-9">
                            <span>{{parkingPassService.selectedItemData.visitorLicensePlate}}</span>
                        </div>
                    </div>

                    <div class="row m-b-xs">
                        <div class="dv-label col-md-3">
                            <label>Created On</label>
                        </div>
                        <div class="dv-value col-md-9">
                            <span>{{parkingPassService.selectedItemData.createdAt ? (parkingPassService.selectedItemData.createdAt | mccDate: true : true) : '-'}}</span>
                        </div>
                    </div>

                    <div class="row m-b-xs">
                        <div class="dv-label col-md-3">
                            <label>Created By</label>
                        </div>
                        <div class="dv-value col-md-9">
                            <span>{{parkingPassService.selectedItemData.createdBy || '-'}}</span>
                        </div>
                    </div>

                    <hr>

                    <div class="row m-b-sm"
                         *ngFor="let pass of parkingPassService.selectedItemData.bookingPassTypes; let index = index;">
                        <div class="col-md-2">
                            <label *ngIf="index == 0">Passes</label>
                        </div>
                        <div class="col-md-10 fourteenPixelText display-inline">
                            <div class="summary-pass-type-name">{{pass.passTypeName}}</div>
                            {{pass.dateFrom | date:'dd.MM.yyyy hh:mm a':'+0000'}} -
                            {{pass.dateTo | date:'dd.MM.yyyy hh:mm a':'+0000'}}
                        </div>
                    </div>
                </div>
                <div *ngIf="navPosition == 'stats'" class="content">
                    <div class="dv-label">
                        <label>Stats for {{currentDate}}</label>
                    </div>
                    <div *ngIf="usedPasses.length > 0 && getUsedPassesString().length > 0" class="m-b-sm">
                        <div *ngFor="let pass of getUsedPassesString()">{{pass.used}} - {{pass.passTypeName}}</div>
                    </div>
                    <div class="dv-label" *ngIf="recentVisitorsList.length > 0">
                        <label>Visitors</label>
                    </div>
                    <div *ngIf="recentVisitorsList.length > 0">
                        <div *ngFor="let visitor of recentVisitorsList">
                            {{ visitor.fullName + ', ' + visitor.vehicle + ', ' + visitor.licensePlate }}
                        </div>
                    </div>
                    <spinner [spinnerShow]="!gotUsedPasses || !gotRecentVisitors"></spinner>
                </div>
                <div *ngIf="navPosition == 'history'" class="content">
                    <h3 class="text-center" style="color: red;">Coming Soon</h3>
                    <div class="timeline">
                        <spinner [spinnerShow]="parkingPassService.historyLoading"></spinner>
                        <ul class="timeline__list" *ngIf="!parkingPassService.historyLoading">
                            <li *ngFor="let a of parkingPassService.history">
                                <section *ngIf="a.action !== 'ignore'">
                                    <header class="timeline__header">
                                    <span>
                                        <time>{{ a.loggedAt | date:'dd.MM.yyyy hh:mm a' }}</time> by {{ a.userFullName }}
                                    </span>
                                    </header>

                                    <main class="timeline__content">
                                        <div [ngSwitch]="a.action">

                                            <ng-template [ngSwitchCase]="'update'">
                                                {{ a.activityType }}
                                                <span class="timeline__active">"{{a.name}}"</span>
                                                <ul class="field-changes">
                                                    <li *ngFor="let item of a.data">
                                                        {{ item?.key }} :
                                                        <span class="timeline__active">"{{ item?.old }}"</span>
                                                        changed to
                                                        <span class="timeline__active">"{{ item?.new }}"</span>
                                                    </li>
                                                </ul>
                                            </ng-template>

                                            <ng-template [ngSwitchCase]="'create'">
                                                <p>
                                                    {{ a.activityType }}
                                                    <span class="timeline__active">"{{a.name}}"</span>
                                                    was received
                                                </p>

                                                <ul class="field-changes">
                                                    <li *ngFor="let item of a.data">
                                                        {{ item.key }} :
                                                        <span class="timeline__active">{{ item.value }}</span>
                                                    </li>
                                                </ul>
                                            </ng-template>

                                        </div>
                                    </main>
                                </section>
                            </li>
                        </ul>
                    </div>
                </div>
            </form>
        </div>

        <hr>

        <div class="btn-group dropup">
            <a data-toggle="dropdown" class="btn btn-primary btn-sm dropdown-toggle">
                Actions <span class="caret"></span>
            </a>
            <ul class="dropdown-menu"
                *ngIf="!authenticationService.userIsResident"
                (click)="$event.showDropdown = true;">
                <li (click)="parkingPassService.approveBooking(parkingPassService.selectedItemData)"
                    *ngIf="parkingPassService.selectedItemData.isCanApprove &&
                           parkingPassService.selectedItemData.status != 'approved' &&
                           parkingPassService.selectedItemData.approvalRequired &&
                           parkingPassService.isBookingDateLaterThanCurrent(parkingPassService.selectedItemData)">
                    <a>Approve</a>
                </li>
                <li *ngIf="parkingPassService.selectedItemData.isCanApprove &&
                           parkingPassService.selectedItemData.approvalRequired &&
                           ((parkingPassService.selectedItemData.status == 'approved' && !parkingPassService.isBookingStartDateLessThanCurrent(parkingPassService.selectedItemData)) ||
                           (parkingPassService.selectedItemData.status == 'pending' && parkingPassService.isBookingDateLaterThanCurrent(parkingPassService.selectedItemData)))"
                    (click)="parkingPassService.declineBooking(parkingPassService.selectedItemData)">
                    <a>Decline</a>
                </li>
                <li *ngIf="parkingPassService.selectedItemData.status != 'pending'"
                    (click)="parkingPassService.printParkingPass(parkingPassService.selectedItemData)">
                    <a>Print</a>
                </li>
                <li *ngIf="parkingPassService.selectedItemData.isCanEdit &&
                           parkingPassService.isBookingDateLaterThanCurrent(parkingPassService.selectedItemData)"
                    (click)="parkingPassService.editParkingPass(parkingPassService.selectedItemData)">
                    <a>Edit</a>
                </li>
                <li *ngIf="canDeleteParkingPass()"
                    (click)="parkingPassService.deleteParkingPass(parkingPassService.selectedItemData.id)">
                    <a>Delete</a>
                </li>
                <li (click)="parkingPassService.viewParkingPass(parkingPassService.selectedItemData)">
                    <a>View</a>
                </li>
            </ul>
            <ul class="dropdown-menu pull-right" *ngIf="authenticationService.userIsResident">
                <li (click)="parkingPassService.editParkingPass(parkingPassService.selectedItemData)"
                    *ngIf="parkingPassService.selectedItemData.isCanEdit && parkingPassService.selectedItemData.status == 'pending'">
                    <a>Edit</a>
                </li>
                <li (click)="parkingPassService.viewParkingPass(parkingPassService.selectedItemData)">
                    <a>View</a>
                </li>
                <li *ngIf="canDeleteParkingPass()"
                    (click)="parkingPassService.deleteParkingPass(parkingPassService.selectedItemData.id)">
                    <a>Delete</a>
                </li>
                <li (click)="parkingPassService.printParkingPass(parkingPassService.selectedItemData)"
                    *ngIf="parkingPassService.selectedItemData.status != 'pending'">
                    <a>Print</a>
                </li>
            </ul>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/parking-pass/parking-pass-detailed-view/parking-pass-detailed-view.component.html